import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import "@fontsource/roboto"; // Defaults to weight 400
import "@fontsource/roboto/400.css"; // Specify weight
import "@fontsource/roboto/400-italic.css"; // Specify weight and style

import "@fontsource/barlow-condensed"; // Defaults to weight 400
import "@fontsource/barlow-condensed/400.css"; // Specify weight
import "@fontsource/barlow-condensed/400-italic.css"; // Specify weight and style

import "@fontsource/roboto-condensed"; // Defaults to weight 400
import "@fontsource/roboto-condensed/400.css"; // Specify weight
import "@fontsource/roboto-condensed/400-italic.css"; // Specify weight and style

import reportWebVitals from './reportWebVitals';
import Login from './screens/Login';
import App from './App'
import Main from './Main';
import StripePayment from './screens/StripePayment';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
